<span class="requires-validation-text" *ngIf="hasErrors">
    <ng-container *ngIf="valStatus.showIncompleteFile">
        <mat-icon class="bolt-icon"
            matTooltip="This record was created in express add. Please complete the file to ensure accurate and complete patient information.">bolt</mat-icon>
        <p class="list-validation-message" *ngIf="!iconsOnly">Incomplete File</p>
    </ng-container>

    <ng-container *ngIf="valStatus.showSelfBoarded">
        <mat-icon class="bolt-icon"
            matTooltip="This record was self-boarded. Please review the information and complete the file to ensure accurate and complete patient information.">medical_information</mat-icon>
        <p class="list-validation-message" *ngIf="!iconsOnly">Patient Information Requires Review</p>
    </ng-container>


    <ng-container *ngIf="valStatus.showICDValidation">
        <mat-icon class="bolt-icon"
            matTooltip="This record was automatically ICD-10 Coded with 'Z00' and diagnosis 'UNSPECIFED'. Please review the diagnosis and update the ICD-10 codes.">warning_amber</mat-icon>
        <p class="list-validation-message" *ngIf="!iconsOnly">Diagnosis/ICD-10 Need Review</p>
    </ng-container>

    <ng-container *ngIf="valStatus.showInviteStatus">
        <mat-icon class="bolt-icon"
            matTooltip="This patient file is still in a pending invite state. Please ensure the patient completes the invite process to ensure accurate and complete patient information.">mail</mat-icon>
        <p class="list-validation-message" *ngIf="!iconsOnly">Invite Status</p>
    </ng-container>
</span>